import * as debugActionsType from '@/constants/debugActionsType';

export function initValue(value) {
  return {
    type: debugActionsType.INIT_VALUE,
    value,
  };
}

export function updateStartingVolume(value) {
  return {
    type: debugActionsType.UPDATE_STARTING_VOLUME,
    value,
  };
}

export function updateStartingConcentration(value) {
  return {
    type: debugActionsType.UPDATE_STARTING_CONCENTRATION,
    value,
  };
}

export function updateFinalVolume(value) {
  return {
    type: debugActionsType.UPDATE_FINAL_VOLUME,
    value,
  };
}

export function updateFinalConcentration(value) {
  return {
    type: debugActionsType.UPDATE_FINAL_CONCENTRATION,
    value,
  };
}

export function updateVolumeToStartAt(value) {
  return {
    type: debugActionsType.UPDATE_VOLUME_TO_START_AT,
    value,
  };
}

export function updateBufferVolumeToUse(value) {
  return {
    type: debugActionsType.UPDATE_BUFER_VOLUME_TO_USE,
    value,
  };
}

export function updateDiafiltrationMode(value) {
  return {
    type: debugActionsType.UPDATE_DIAFILTRATION_MODE,
    value,
  };
}

export function runProteinConcentrator(value) {
  return {
    type: debugActionsType.RUN_PROTEIN_CONCENTRATOR,
    value,
  };
}

export function pauseProteinConcentrator(value) {
  return {
    type: debugActionsType.PAUSE_PROTEIN_CONCENTRATOR,
    value,
  };
}

export function runPrimingMode(value) {
  return {
    type: debugActionsType.RUN_PRIMING_MODE,
    value,
  };
}

export function runConcentratingMode(value) {
  return {
    type: debugActionsType.RUN_CONCENTRATING_MODE,
    value,
  };
}

export function runDiafiltratingMode(value) {
  return {
    type: debugActionsType.RUN_DIAFILTRATING_MODE,
    value,
  };
}

export function stopProteinConcentrator(value) {
  return {
    type: debugActionsType.STOP_PROTEIN_CONCENTRATOR,
    value,
  };
}

export function updateDiaphragmVacuumPressure(value) {
  return {
    type: debugActionsType.UPDATE_DIAPHRAGM_VACUUM_PRESSURE,
    value,
  };
}

export function updateDiaphragmPressure(value) {
  return {
    type: debugActionsType.UPDATE_DIAPHRAGM_PRESSURE,
    value,
  };
}

export function updateDiaphragmTiming(value) {
  return {
    type: debugActionsType.UPDATE_DIAPHRAGM_TIMING,
    value,
  };
}

export function updateValveTiming(value) {
  return {
    type: debugActionsType.UPDATE_VALVE_TIMING,
    value,
  };
}

export function updateShowWarning(value) {
  return {
    type: debugActionsType.UPDATE_SHOW_WARNING,
    value,
  };
}

export function autoCalibrate(value) {
  return {
    type: debugActionsType.AUTO_CALIBRATE,
    value,
  };
}

export function resetToDefault(value) {
  return {
    type: debugActionsType.RESET_TO_DEFAULT,
    value,
  };
}

//-------------------------------------------------------
// Advanced Setup
//-------------------------------------------------------
export function updateOperatingPressure(value) {
  return {
    type: debugActionsType.UPDATE_OPERATING_PRESURE,
    value,
  };
}

export function updateRecoveryOfLiquid(value) {
  return {
    type: debugActionsType.UPDATE_RECOVERY_OF_LIQUID,
    value,
  };
}

export function updateFlowRate(value) {
  return {
    type: debugActionsType.UPDATE_FLOW_RATE,
    value,
  };
}

export function updatePCState(value) {
  return {
    type: debugActionsType.UPDATE_PC_STATE,
    value,
  };
}

//-------------------------------------------------------
// Status Progress Bar
//-------------------------------------------------------
export function updatePercentageProgressBar(value) {
  return {
    type: debugActionsType.UPDATE_PERCENTAGE_PROGRESS_BAR,
    value,
  };
}

export function updateEstimateTime(value) {
  return {
    type: debugActionsType.UPDATE_ESTIMATE_TIME,
    value,
  };
}

export function updateProgressBarStatus(value) {
  return {
    type: debugActionsType.UPDATE_PROGRESSBAR_STATUS,
    value,
  };
}
export function updateStatus(value) {
  return {
    type: debugActionsType.UPDATE_STATUS,
    value,
  };
}
// slider current volume
export function updateCurrentVolume(value) {
  return {
    type: debugActionsType.UPDATE_CURRENT_VOLUME,
    value,
  };
}
export function updateCurrentBuffer(value) {
  return {
    type: debugActionsType.UPDATE_CURRENT_BUFFER,
    value,
  };
}
export function updateDummyBuffer(value) {
  return {
    type: debugActionsType.UPDATE_DUMMY_BUFFER,
    value,
  };
}

export function updateStoppingFromButton(value) {
  return {
    type: debugActionsType.UPDATE_STOPPING_FROM_BUTTON,
    value,
  };
}
export function updateActiveMenu(value) {
  return {
    type: debugActionsType.UPDATE_ACTIVE_MENU,
    value,
  };
}

//-------------------------------------------------------
// Explorer page
//-------------------------------------------------------
export function updateProfileList(value) {
  return {
    type: debugActionsType.UPDATE_PROFILE_LIST,
    value,
  };
}
export function profileSelected(value) {
  return {
    type: debugActionsType.PROFILE_SELECTED,
    value,
  };
}
export function updateProfileName(value) {
  return {
    type: debugActionsType.UPDATE_PROFILE_NAME,
    value,
  };
}

export function profileSettingExplorer(value) {
  return {
    type: debugActionsType.PROFILE_SETTING_EXPLORER,
    value,
  };
}

export function updateAllValue(value) {
  return {
    type: debugActionsType.UPDATE_ALL_VALUE,
    value,
  };
}
export function updateShowProfile(value) {
  return {
    type: debugActionsType.UPDATE_SHOW_PROFILE,
    value,
  };
}
export function lastProfileIdView(value) {
  return {
    type: debugActionsType.UPDATE_LAST_PROFILE_ID_VIEW,
    value,
  };
}

// alert
export function showAlert(value) {
  return {
    type: debugActionsType.SHOW_ALERT,
    value,
  };
}

// hardware value
export function hardwareValue(value) {
  return {
    type: debugActionsType.HARDWARE_VALUE,
    value,
  };
}

// update debug
export function getSetup(value) {
  return {
    type: debugActionsType.GET_SETUP,
    value,
  };
}

// update status
export function getStatus(value) {
  return {
    type: debugActionsType.GET_STATUS,
    value,
  };
}

// update other info
export function getOtherInfo(value) {
  return {
    type: debugActionsType.GET_OTHER_INFO,
    value,
  };
}
export function serialConnect(value) {
  return {
    type: debugActionsType.SERIAL_CONNECT,
    value,
  };
}

// MESSAGE

export function error(value) {
  return {
    type: debugActionsType.ERROR_MESSAGE,
    value,
  };
}
export function success(value) {
  return {
    type: debugActionsType.SUCCESS_MESSAGE,
    value,
  };
}
export function failure(value) {
  return {
    type: debugActionsType.FAILURE_MESSAGE,
    value,
  };
}
export function warning(value) {
  return {
    type: debugActionsType.WARNING_MESSAGE,
    value,
  };
}
export function clearMessage(value) {
  return {
    type: debugActionsType.CLEAR_MESSAGE,
    value,
  };
}

export function updateSensorValue(value) {
  return {
    type: debugActionsType.UPDATE_SENSOR_VALUE,
    value,
  };
}
export function startSequenceDesigner(value) {
  return {
    type: debugActionsType.START_SEQUENCE_DESIGNER,
    value,
  };
}
export function stopSequenceDesigner(value) {
  return {
    type: debugActionsType.STOP_SEQUENCE_DESIGNER,
    value,
  };
}
export function pauseSequenceDesigner(value) {
  return {
    type: debugActionsType.PAUSE_SEQUENCE_DESIGNER,
    value,
  };
}
export function resumeSequenceDesigner(value) {
  return {
    type: debugActionsType.RESUME_SEQUENCE_DESIGNER,
    value,
  };
}
// other info
export function updateOtherInfo(value) {
  return {
    type: debugActionsType.UPDATE_OTHER_INFO,
    value,
  };
}
